/**
 * To control the history scrolling when selecting dates
 *
 * @author Jess McClary <github.com/kinsDeveloper>
 */
(function ($) {
  'use strict';

  let $year;
  let $slide;

  Drupal.behaviors.initializeHistoryScroll = {
    attach: (context) => {
      if (context === document) {
        initialize();
      }
    },
  };

  function handleClick(e) {
    const $el = $(e.currentTarget);
    const id = $el.data('info-id');
    const $slide_id = $(`#${id}`);

    $el.parent().children('.is-active').removeClass('is-active');
    $el.addClass('is-active');
    $slide_id.parent().children('.is-active').removeClass('is-active');
    $slide_id.addClass('is-active');
  }

  function initialize() {
    $year = $('#historical-container .years p');
    $slide = $('#historical-container .slick-slider > div');

    if (!$year.length) return false;

    $year.first().addClass('is-active');
    $('#historical-container .details:first-child').addClass('is-active');

    $year.on('click', handleClick);

    $slide.each(function () {
      const $el = $(this);

      $el.slick({
        slidesToShow: 7,
        slidesToScroll: 1,
        vertical: true,
        autoplay: false,
        arrows: true,
        draggable: true,
        swipe: true,
        touchThreshold: 100,
        prevArrow: '<div class="slick-prev"></div>',
        nextArrow: '<div class="slick-next"></div>',
      });
    });
  }
})(jQuery);
